import { GUARDS_IMGS } from './constants'

const { mert, squid, wetmore, starling, laverne, hopps } = GUARDS_IMGS

export const guards = [{
  name: 'Guard Mert',
  resource: 'The Shawshank Redemption',
  picture: mert,
  firstJoke: 'Duframe, you are mine now!'

}, {
  name: 'Pink Soldier',
  resource: 'Squid Game',
  picture: squid,
  firstJoke: 'Life is like a game, there are many players. If you don’t play with them, they’ll play with you.'

}, {
  name: 'Percy Wetmore',
  resource: 'Green mile',
  picture: wetmore,
  firstJoke: 'I didn\'t know the sponge is supposed to be wet.'

}, {
  name: 'Clarice Starling',
  resource: 'The Silence of the Lambs',
  picture: starling,
  firstJoke: 'Cops Look At You To See How To Act. It Matters.'
}, {
  name: 'Laverne Hooks',
  resource: 'Police Academy',
  picture: laverne,
  firstJoke: 'I wanna be a police officer.'
}, {
  name: 'Judy Hopps',
  resource: 'Zootopia',
  picture: hopps,
  firstJoke: 'Sir, I\'m not just some token bunny.'
}

]
